import { Locale } from '../modules/locales/locale.model'

export const LOCALE_DEFAULT_CODE = 'default'

export const LOCALES_LIST: Locale[] = [
  {
    language: 'Aghem',
    location: 'Cameroon',
    tag: 'agq_CM',
    name: 'agq-cm',
  },
  {
    language: 'Blin',
    location: 'Eritrea',
    tag: 'byn_ER',
    name: 'byn-er',
  },
  {
    language: 'English',
    location: 'Isle of Man',
    tag: 'en_IM',
    name: 'en-im',
  },
  {
    language: 'English',
    location: 'Jamaica',
    tag: 'en_JM',
    name: 'en-jm',
  },
  {
    language: 'Portuguese',
    location: 'Timor-Leste',
    tag: 'pt_TL',
    name: 'pt-tl',
  },
  {
    language: 'Spanish',
    location: 'Bolivarian Republic of Venezuela',
    tag: 'es_VE',
    name: 'es-ve',
  },
  {
    language: 'English',
    location: 'Ireland',
    tag: 'en_IE',
    name: 'en-ie',
  },
  {
    language: 'English',
    location: 'Nauru',
    tag: 'en_NR',
    name: 'en-nr',
  },
  {
    language: 'Asu',
    location: 'Tanzania',
    tag: 'asa_TZ',
    name: 'asa-tz',
  },
  {
    language: 'English',
    location: 'New Zealand',
    tag: 'en_NZ',
    name: 'en-nz',
  },
  {
    language: 'Chinese (Simplified)',
    location: "People's Republic of China",
    tag: 'zh_CN',
    name: 'zh-cn',
  },
  {
    language: 'English',
    location: 'Ghana',
    tag: 'en_GH',
    name: 'en-gh',
  },
  {
    language: 'Marathi',
    location: 'India',
    tag: 'mr_IN',
    name: 'mr-in',
  },
  {
    language: 'German',
    location: 'Italy',
    tag: 'de_IT',
    name: 'de-it',
  },
  {
    language: 'Hebrew',
    location: 'Israel',
    tag: 'he_IL',
    name: 'he-il',
  },
  {
    language: 'Shona',
    location: 'Zimbabwe',
    tag: 'sn_Latn-ZW',
    name: 'sn-latn-zw',
  },
  {
    language: 'Ripuarian',
    location: 'Germany',
    tag: 'ksh_DE',
    name: 'ksh-de',
  },
  {
    language: 'Arabic',
    location: 'Palestinian Authority',
    tag: 'ar_PS',
    name: 'ar-ps',
  },
  {
    language: 'Serbian (Cyrillic)',
    location: 'Montenegro',
    tag: 'sr_Cyrl-ME',
    name: 'sr-cyrl-me',
  },
  {
    language: 'Uzbek',
    location: 'Perso-Arabic, Afghanistan',
    tag: 'uz_Arab-AF',
    name: 'uz-arab-af',
  },
  {
    language: 'Vietnamese',
    location: 'Vietnam',
    tag: 'vi_VN',
    name: 'vi-vn',
  },
  {
    language: 'Norwegian Bokmål',
    location: 'Svalbard and Jan Mayen',
    tag: 'nb_SJ',
    name: 'nb-sj',
  },
  {
    language: 'Yangben',
    location: 'Cameroon',
    tag: 'yav_CM',
    name: 'yav-cm',
  },
  {
    language: 'Arabic',
    location: 'Lebanon',
    tag: 'ar_LB',
    name: 'ar-lb',
  },
  {
    language: 'Arabic',
    location: 'Tunisia',
    tag: 'ar_TN',
    name: 'ar-tn',
  },
  {
    language: 'English',
    location: 'St Helena, Ascension,  Tristan da Cunha',
    tag: 'en_SH',
    name: 'en-sh',
  },
  {
    language: 'English',
    location: 'Turks and Caicos Islands',
    tag: 'en_TC',
    name: 'en-tc',
  },
  {
    language: 'Dutch',
    location: 'Netherlands',
    tag: 'nl_NL',
    name: 'nl-nl',
  },
  {
    language: 'French',
    location: 'Burundi',
    tag: 'fr_BI',
    name: 'fr-bi',
  },
  {
    language: 'Sindhi',
    location: 'Islamic Republic of Pakistan',
    tag: 'sd_Arab-PK',
    name: 'sd-arab-pk',
  },
  {
    language: 'French',
    location: 'Reunion',
    tag: 'fr_RE',
    name: 'fr-re',
  },
  {
    language: 'Spanish',
    location: 'Guatemala',
    tag: 'es_GT',
    name: 'es-gt',
  },
  {
    language: 'French',
    location: 'Guadeloupe',
    tag: 'fr_GP',
    name: 'fr-gp',
  },
  {
    language: 'Tibetan',
    location: "People's Republic of China",
    tag: 'bo_CN',
    name: 'bo-cn',
  },
  {
    language: 'Swedish',
    location: 'Sweden',
    tag: 'sv_SE',
    name: 'sv-se',
  },
  {
    language: 'Tachelhit (Latin)',
    location: 'Morocco',
    tag: 'shi_Latn-MA',
    name: 'shi-latn-ma',
  },
  {
    language: 'Portuguese',
    location: 'Brazil',
    tag: 'pt_BR',
    name: 'pt-br',
  },
  {
    language: 'Spanish',
    location: 'Cuba',
    tag: 'es_CU',
    name: 'es-cu',
  },
  {
    language: 'English',
    location: 'Gambia',
    tag: 'en_GM',
    name: 'en-gm',
  },
  {
    language: 'English',
    location: 'Republic of the Philippines',
    tag: 'en_PH',
    name: 'en-ph',
  },
  {
    language: 'Hindi',
    location: 'India',
    tag: 'hi_IN',
    name: 'hi-in',
  },
  {
    language: 'Mundang',
    location: 'Cameroon',
    tag: 'mua_CM',
    name: 'mua-cm',
  },
  {
    language: 'Russian',
    location: 'Ukraine',
    tag: 'ru_UA',
    name: 'ru-ua',
  },
  {
    language: 'Samburu',
    location: 'Kenya',
    tag: 'saq_KE',
    name: 'saq-ke',
  },
  {
    language: 'Swati',
    location: 'South Africa',
    tag: 'ss_ZA',
    name: 'ss-za',
  },
  {
    language: 'Wolaytta',
    location: 'Ethiopia',
    tag: 'wal_ET',
    name: 'wal-et',
  },
  {
    language: 'Norwegian (Nynorsk)',
    location: 'Norway',
    tag: 'nn_NO',
    name: 'nn-no',
  },
  {
    language: 'Spanish',
    location: 'Colombia',
    tag: 'es_CO',
    name: 'es-co',
  },
  {
    language: 'Zulu',
    location: 'South Africa',
    tag: 'zu_ZA',
    name: 'zu-za',
  },
  {
    language: 'Armenian',
    location: 'Armenia',
    tag: 'hy_AM',
    name: 'hy-am',
  },
  {
    language: 'Hausa (Latin)',
    location: 'Ghana',
    tag: 'ha_Latn-GH',
    name: 'ha-latn-gh',
  },
  {
    language: 'Scottish Gaelic',
    location: 'United Kingdom',
    tag: 'gd_GB',
    name: 'gd-gb',
  },
  {
    language: 'Alsatian',
    location: 'Switzerland',
    tag: 'gsw_CH',
    name: 'gsw-ch',
  },
  {
    language: 'Amharic',
    location: 'Ethiopia',
    tag: 'am_ET',
    name: 'am-et',
  },
  {
    language: 'Dutch',
    location: 'Aruba',
    tag: 'nl_AW',
    name: 'nl-aw',
  },
  {
    language: 'Kiswahili',
    location: 'Uganda',
    tag: 'sw_UG',
    name: 'sw-ug',
  },
  {
    language: 'Korean',
    location: 'North Korea',
    tag: 'ko_KP',
    name: 'ko-kp',
  },
  {
    language: 'French',
    location: 'Mauritius',
    tag: 'fr_MU',
    name: 'fr-mu',
  },
  {
    language: 'Serbian (Latin)',
    location: 'Serbia and Montenegro (Former)',
    tag: 'sr_Latn-CS',
    name: 'sr-latn-cs',
  },
  {
    language: 'Tongan',
    location: 'Tonga',
    tag: 'to_TO',
    name: 'to-to',
  },
  {
    language: 'Afrikaans',
    location: 'Namibia',
    tag: 'af_NA',
    name: 'af-na',
  },
  {
    language: 'Hausa (Latin)',
    location: 'Niger',
    tag: 'ha_Latn-NE',
    name: 'ha-latn-ne',
  },
  {
    language: 'Kalenjin',
    location: 'Kenya',
    tag: 'kln_KE',
    name: 'kln-ke',
  },
  {
    language: 'Chakma',
    location: 'Chakma',
    tag: 'ccp_Cakm',
    name: 'ccp-cakm',
  },
  {
    language: 'English',
    location: 'Anguilla',
    tag: 'en_AI',
    name: 'en-ai',
  },
  {
    language: 'Valencian',
    location: 'Spain',
    tag: 'ca_ES-',
    name: 'ca-es-',
  },
  {
    language: 'French',
    location: 'Mauritania',
    tag: 'fr_MR',
    name: 'fr-mr',
  },
  {
    language: 'French',
    location: 'Principality of Monaco',
    tag: 'fr_MC',
    name: 'fr-mc',
  },
  {
    language: 'Lower Sorbian',
    location: 'Germany',
    tag: 'dsb_DE',
    name: 'dsb-de',
  },
  {
    language: 'Walser',
    location: 'Switzerland',
    tag: 'wae_CH',
    name: 'wae-ch',
  },
  {
    language: 'Arabic',
    location: 'Mauritania',
    tag: 'ar_MR',
    name: 'ar-mr',
  },
  {
    language: 'Romanian',
    location: 'Romania',
    tag: 'ro_RO',
    name: 'ro-ro',
  },
  {
    language: 'Mongolian (Traditional Mongolian)',
    location: 'Mongolia',
    tag: 'mn_Mong-MN',
    name: 'mn-mong-mn',
  },
  {
    language: 'Arabic',
    location: 'South Sudan',
    tag: 'ar_SS',
    name: 'ar-ss',
  },
  {
    language: 'Setswana',
    location: 'Botswana',
    tag: 'tn_BW',
    name: 'tn-bw',
  },
  {
    language: 'Fulah',
    location: 'Cameroon',
    tag: 'ff_CM',
    name: 'ff-cm',
  },
  {
    language: 'Kannada',
    location: 'India',
    tag: 'kn_IN',
    name: 'kn-in',
  },
  {
    language: 'Morisyen',
    location: 'Mauritius',
    tag: 'mfe_MU',
    name: 'mfe-mu',
  },
  {
    language: 'Kashmiri',
    location: 'Perso-Arabic',
    tag: 'ks_Arab-IN',
    name: 'ks-arab-in',
  },
  {
    language: 'Spanish',
    location: 'Puerto Rico',
    tag: 'es_PR',
    name: 'es-pr',
  },
  {
    language: 'Dutch',
    location: 'Bonaire, Sint Eustatius and Saba',
    tag: 'nl_BQ',
    name: 'nl-bq',
  },
  {
    language: 'English',
    location: 'Guernsey',
    tag: 'en_GG',
    name: 'en-gg',
  },
  {
    language: 'Mongolian (Cyrillic)',
    location: 'Mongolia',
    tag: 'mn_MN',
    name: 'mn-mn',
  },
  {
    language: 'Esperanto',
    location: 'World',
    tag: 'eo_001',
    name: 'eo-001',
  },
  {
    language: 'Mapudungun',
    location: 'Chile',
    tag: 'arn_CL',
    name: 'arn-cl',
  },
  {
    language: 'Croatian',
    location: 'Croatia',
    tag: 'hr_HR',
    name: 'hr-hr',
  },
  {
    language: 'English',
    location: 'Northern Mariana Islands',
    tag: 'en_MP',
    name: 'en-mp',
  },
  {
    language: 'Church Slavic',
    location: 'Russia',
    tag: 'cu_RU',
    name: 'cu-ru',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Nigeria',
    tag: 'ff_Latn-NG',
    name: 'ff-latn-ng',
  },
  {
    language: 'Tsonga',
    location: 'South Africa',
    tag: 'ts_ZA',
    name: 'ts-za',
  },
  {
    language: 'Albanian',
    location: 'North Macedonia',
    tag: 'sq_MK',
    name: 'sq-mk',
  },
  {
    language: 'English',
    location: 'South Africa',
    tag: 'en_ZA',
    name: 'en-za',
  },
  {
    language: 'Nepali',
    location: 'India',
    tag: 'ne_IN',
    name: 'ne-in',
  },
  {
    language: 'Fulah',
    location: 'Guinea',
    tag: 'ff_GN',
    name: 'ff-gn',
  },
  {
    language: 'Hungarian',
    location: 'Hungary',
    tag: 'hu_HU',
    name: 'hu-hu',
  },
  {
    language: 'English',
    location: 'Burundi',
    tag: 'en_BI',
    name: 'en-bi',
  },
  {
    language: 'French',
    location: 'French Guiana',
    tag: 'fr_GF',
    name: 'fr-gf',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Guinea-Bissau',
    tag: 'ff_Latn-GW',
    name: 'ff-latn-gw',
  },
  {
    language: 'Low German',
    location: 'Germany',
    tag: 'nds_DE',
    name: 'nds-de',
  },
  {
    language: 'Bamanankan (Latin)',
    location: 'Mali',
    tag: 'bm_Latn-ML',
    name: 'bm-latn-ml',
  },
  {
    language: 'French',
    location: 'Haiti',
    tag: 'fr_HT',
    name: 'fr-ht',
  },
  {
    language: 'French',
    location: 'Togo',
    tag: 'fr_TG',
    name: 'fr-tg',
  },
  {
    language: 'Polish',
    location: 'Poland',
    tag: 'pl_PL',
    name: 'pl-pl',
  },
  {
    language: 'Yi',
    location: "People's Republic of China",
    tag: 'ii_CN',
    name: 'ii-cn',
  },
  {
    language: 'Basaa',
    location: 'Cameroon',
    tag: 'bas_CM',
    name: 'bas-cm',
  },
  {
    language: 'Setswana',
    location: 'South Africa',
    tag: 'tn_ZA',
    name: 'tn-za',
  },
  {
    language: 'Chinese (Traditional)',
    location: 'Hong Kong S.A.R.',
    tag: 'zh_HK',
    name: 'zh-hk',
  },
  {
    language: 'English',
    location: 'Pitcairn Islands',
    tag: 'en_PN',
    name: 'en-pn',
  },
  {
    language: 'French',
    location: 'Senegal',
    tag: 'fr_SN',
    name: 'fr-sn',
  },
  {
    language: 'Low German',
    location: 'Netherlands',
    tag: 'nds_NL',
    name: 'nds-nl',
  },
  {
    language: 'English',
    location: 'Germany',
    tag: 'en_DE',
    name: 'en-de',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Cameroon',
    tag: 'ff_Latn-CM',
    name: 'ff-latn-cm',
  },
  {
    language: 'Galician',
    location: 'Spain',
    tag: 'gl_ES',
    name: 'gl-es',
  },
  {
    language: 'Rombo',
    location: 'Tanzania',
    tag: 'rof_TZ',
    name: 'rof-tz',
  },
  {
    language: 'Sango',
    location: 'Central African Republic',
    tag: 'sg_CF',
    name: 'sg-cf',
  },
  {
    language: 'Spanish',
    location: 'Bolivia',
    tag: 'es_BO',
    name: 'es-bo',
  },
  {
    language: 'Volapük',
    location: 'World',
    tag: 'vo_001',
    name: 'vo-001',
  },
  {
    language: 'Chakma',
    location: 'India',
    tag: 'ccp_Cakm-',
    name: 'ccp-cakm-',
  },
  {
    language: 'Spanish',
    location: 'Ecuador',
    tag: 'es_EC',
    name: 'es-ec',
  },
  {
    language: 'Occitan',
    location: 'France',
    tag: 'oc_FR',
    name: 'oc-fr',
  },
  {
    language: 'Masai',
    location: 'Tanzania',
    tag: 'mas_TZ',
    name: 'mas-tz',
  },
  {
    language: 'Frisian',
    location: 'Netherlands',
    tag: 'fy_NL',
    name: 'fy-nl',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Burkina Faso',
    tag: 'ff_Latn-BF',
    name: 'ff-latn-bf',
  },
  {
    language: 'Oromo',
    location: 'Kenya',
    tag: 'om_KE',
    name: 'om-ke',
  },
  {
    language: 'Bena',
    location: 'Tanzania',
    tag: 'bez_TZ',
    name: 'bez-tz',
  },
  {
    language: 'Nama',
    location: 'Namibia',
    tag: 'naq_NA',
    name: 'naq-na',
  },
  {
    language: 'English',
    location: 'Bermuda',
    tag: 'en_BM',
    name: 'en-bm',
  },
  {
    language: 'Spanish',
    location: 'Belize',
    tag: 'es_BZ',
    name: 'es-bz',
  },
  {
    language: 'Catalan',
    location: 'Italy',
    tag: 'ca_IT',
    name: 'ca-it',
  },
  {
    language: 'Central Kurdish',
    location: 'Iraq',
    tag: 'ku_Arab-IQ',
    name: 'ku-arab-iq',
  },
  {
    language: 'English',
    location: 'Israel',
    tag: 'en_IL',
    name: 'en-il',
  },
  {
    language: 'English',
    location: 'Swaziland',
    tag: 'en_SZ',
    name: 'en-sz',
  },
  {
    language: 'French',
    location: 'Congo',
    tag: 'fr_CG',
    name: 'fr-cg',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Sierra Leone',
    tag: 'ff_Latn-SL',
    name: 'ff-latn-sl',
  },
  {
    language: 'Portuguese',
    location: 'Mozambique',
    tag: 'pt_MZ',
    name: 'pt-mz',
  },
  {
    language: 'Sami (Northern)',
    location: 'Sweden',
    tag: 'se_SE',
    name: 'se-se',
  },
  {
    language: 'Kabyle',
    location: 'Algeria',
    tag: 'kab_DZ',
    name: 'kab-dz',
  },
  {
    language: 'Arabic',
    location: 'Chad',
    tag: 'ar_TD',
    name: 'ar-td',
  },
  {
    language: 'English',
    location: 'Puerto Rico',
    tag: 'en_PR',
    name: 'en-pr',
  },
  {
    language: 'French',
    location: 'Belgium',
    tag: 'fr_BE',
    name: 'fr-be',
  },
  {
    language: 'Gujarati',
    location: 'India',
    tag: 'gu_IN',
    name: 'gu-in',
  },
  {
    language: 'English',
    location: 'United Kingdom',
    tag: 'en_GB',
    name: 'en-gb',
  },
  {
    language: 'French',
    location: 'Saint Pierre and Miquelon',
    tag: 'fr_PM',
    name: 'fr-pm',
  },
  {
    language: 'Pashto',
    location: 'Afghanistan',
    tag: 'ps_AF',
    name: 'ps-af',
  },
  {
    language: 'Syriac',
    location: 'Syria',
    tag: 'syr_SY',
    name: 'syr-sy',
  },
  {
    language: 'Arabic',
    location: 'Morocco',
    tag: 'ar_MA',
    name: 'ar-ma',
  },
  {
    language: 'Ganda',
    location: 'Uganda',
    tag: 'lg_UG',
    name: 'lg-ug',
  },
  {
    language: 'Russian',
    location: 'Moldova',
    tag: 'ru_MD',
    name: 'ru-md',
  },
  {
    language: 'Spanish',
    location: 'Honduras',
    tag: 'es_HN',
    name: 'es-hn',
  },
  {
    language: 'French',
    location: 'Saint Barthélemy',
    tag: 'fr_BL',
    name: 'fr-bl',
  },
  {
    language: 'Arabic',
    location: 'World',
    tag: 'ar_001',
    name: 'ar-001',
  },
  {
    language: 'Pseudo Language',
    location: 'Pseudo locale used for localization testing of mirrored locales',
    tag: 'qps_plocm',
    name: 'qps-plocm',
  },
  {
    language: 'Teso',
    location: 'Kenya',
    tag: 'teo_KE',
    name: 'teo-ke',
  },
  {
    language: 'English',
    location: 'Cook Islands',
    tag: 'en_CK',
    name: 'en-ck',
  },
  {
    language: 'Arabic',
    location: 'U.A.E.',
    tag: 'ar_AE',
    name: 'ar-ae',
  },
  {
    language: 'Bashkir',
    location: 'Russia',
    tag: 'ba_RU',
    name: 'ba-ru',
  },
  {
    language: 'Duala',
    location: 'Cameroon',
    tag: 'dua_CM',
    name: 'dua-cm',
  },
  {
    language: 'English',
    location: 'Tanzania',
    tag: 'en_TZ',
    name: 'en-tz',
  },
  {
    language: 'English',
    location: 'Sint Maarten',
    tag: 'en_SX',
    name: 'en-sx',
  },
  {
    language: 'Faroese',
    location: 'Denmark',
    tag: 'fo_DK',
    name: 'fo-dk',
  },
  {
    language: 'Spanish',
    location: 'UnitedStates',
    tag: 'es_US',
    name: 'es-us',
  },
  {
    language: 'Lingala',
    location: 'Central African Republic',
    tag: 'ln_CF',
    name: 'ln-cf',
  },
  {
    language: 'Ossetian',
    location: 'Cyrillic, Russia',
    tag: 'os_RU',
    name: 'os-ru',
  },
  {
    language: 'Quechua',
    location: 'Peru',
    tag: 'quz_PE',
    name: 'quz-pe',
  },
  {
    language: 'Azerbaijani (Latin)',
    location: 'Azerbaijan',
    tag: 'az_Latn-AZ',
    name: 'az-latn-az',
  },
  {
    language: 'English',
    location: 'Saint Vincent and the Grenadines',
    tag: 'en_VC',
    name: 'en-vc',
  },
  {
    language: 'Luo',
    location: 'Kenya',
    tag: 'luo_KE',
    name: 'luo-ke',
  },
  {
    language: 'Spanish',
    location: 'Paraguay',
    tag: 'es_PY',
    name: 'es-py',
  },
  {
    language: 'Northern Luri',
    location: 'Iraq',
    tag: 'lrc_IQ',
    name: 'lrc-iq',
  },
  {
    language: 'English',
    location: 'British Indian Ocean Territory',
    tag: 'en_IO',
    name: 'en-io',
  },
  {
    language: 'Ewondo',
    location: 'Cameroon',
    tag: 'ewo_CM',
    name: 'ewo-cm',
  },
  {
    language: 'Portuguese',
    location: 'Switzerland',
    tag: 'pt_CH',
    name: 'pt-ch',
  },
  {
    language: 'Tamil',
    location: 'India',
    tag: 'ta_IN',
    name: 'ta-in',
  },
  {
    language: 'Xhosa',
    location: 'South Africa',
    tag: 'xh_ZA',
    name: 'xh-za',
  },
  {
    language: 'French',
    location: 'Canada',
    tag: 'fr_CA',
    name: 'fr-ca',
  },
  {
    language: 'English',
    location: 'Namibia',
    tag: 'en_NA',
    name: 'en-na',
  },
  {
    language: 'Sami (Northern)',
    location: 'Finland',
    tag: 'se_FI',
    name: 'se-fi',
  },
  {
    language: 'Spanish',
    location: 'Argentina',
    tag: 'es_AR',
    name: 'es-ar',
  },
  {
    language: 'Somali',
    location: 'Djibouti',
    tag: 'so_DJ',
    name: 'so-dj',
  },
  {
    language: 'Chinese (Simplified)',
    location: 'Singapore',
    tag: 'zh_SG',
    name: 'zh-sg',
  },
  {
    language: 'Korean',
    location: 'Korea',
    tag: 'ko_KR',
    name: 'ko-kr',
  },
  {
    language: 'Spanish',
    location: 'Panama',
    tag: 'es_PA',
    name: 'es-pa',
  },
  {
    language: 'French',
    location: 'Switzerland',
    tag: 'fr_CH',
    name: 'fr-ch',
  },
  {
    language: 'Spanish',
    location: 'Spain',
    tag: 'es_ES',
    name: 'es-es',
  },
  {
    language: 'Catalan',
    location: 'Andorra',
    tag: 'ca_AD',
    name: 'ca-ad',
  },
  {
    language: 'Rundi',
    location: 'Burundi',
    tag: 'rn_BI',
    name: 'rn-bi',
  },
  {
    language: 'Pashto',
    location: 'Pakistan',
    tag: 'ps_PK',
    name: 'ps-pk',
  },
  {
    language: 'Persian',
    location: 'Afghanistan',
    tag: 'fa_AF',
    name: 'fa-af',
  },
  {
    language: 'Somali',
    location: 'Kenya',
    tag: 'so_KE',
    name: 'so-ke',
  },
  {
    language: 'Portuguese',
    location: 'Luxembourg',
    tag: 'pt_LU',
    name: 'pt-lu',
  },
  {
    language: 'English',
    location: 'United Arab Emirates',
    tag: 'en_AE',
    name: 'en-ae',
  },
  {
    language: 'Spanish',
    location: 'Equatorial Guinea',
    tag: 'es_GQ',
    name: 'es-gq',
  },
  {
    language: 'Alsatian',
    location: 'France',
    tag: 'gsw_FR',
    name: 'gsw-fr',
  },
  {
    language: 'English',
    location: 'Bahamas',
    tag: 'en_BS',
    name: 'en-bs',
  },
  {
    language: 'French',
    location: 'Tunisia',
    tag: 'fr_TN',
    name: 'fr-tn',
  },
  {
    language: 'Serbian (Latin)',
    location: 'Serbia',
    tag: 'sr_Latn-RS',
    name: 'sr-latn-rs',
  },
  {
    language: 'Kiswahili',
    location: 'Tanzania',
    tag: 'sw_TZ',
    name: 'sw-tz',
  },
  {
    language: 'Lingala',
    location: 'Congo DRC',
    tag: 'ln_CD',
    name: 'ln-cd',
  },
  {
    language: 'Sami (Southern)',
    location: 'Norway',
    tag: 'sma_NO',
    name: 'sma-no',
  },
  {
    language: 'English',
    location: 'Barbados',
    tag: 'en_BB',
    name: 'en-bb',
  },
  {
    language: 'Makhuwa-Meetto',
    location: 'Mozambique',
    tag: 'mgh_MZ',
    name: 'mgh-mz',
  },
  {
    language: 'Norwegian (Bokmal)',
    location: 'Norway',
    tag: 'nb_NO',
    name: 'nb-no',
  },
  {
    language: 'Afrikaans',
    location: 'South Africa',
    tag: 'af_ZA',
    name: 'af-za',
  },
  {
    language: 'Arabic',
    location: 'Israel',
    tag: 'ar_IL',
    name: 'ar-il',
  },
  {
    language: 'English',
    location: 'Kiribati',
    tag: 'en_KI',
    name: 'en-ki',
  },
  {
    language: 'Turkish',
    location: 'Cyprus',
    tag: 'tr_CY',
    name: 'tr-cy',
  },
  {
    language: 'Dari',
    location: 'Afghanistan',
    tag: 'prs_AF',
    name: 'prs-af',
  },
  {
    language: 'English',
    location: 'Sierra Leone',
    tag: 'en_SL',
    name: 'en-sl',
  },
  {
    language: 'Spanish',
    location: 'Chile',
    tag: 'es_CL',
    name: 'es-cl',
  },
  {
    language: 'French',
    location: "Côte d'Ivoire",
    tag: 'fr_CI',
    name: 'fr-ci',
  },
  {
    language: 'Breton',
    location: 'France',
    tag: 'br_FR',
    name: 'br-fr',
  },
  {
    language: 'English',
    location: 'Caribbean',
    tag: 'en_029',
    name: 'en-029',
  },
  {
    language: 'Southern Sotho',
    location: 'Lesotho',
    tag: 'st_LS',
    name: 'st-ls',
  },
  {
    language: 'Uzbek (Latin)',
    location: 'Uzbekistan',
    tag: 'uz_Latn-UZ',
    name: 'uz-latn-uz',
  },
  {
    language: 'English',
    location: 'United States',
    tag: 'en_US',
    name: 'en-us',
  },
  {
    language: 'Nuer',
    location: 'Sudan',
    tag: 'nus_SD',
    name: 'nus-sd',
  },
  {
    language: 'Portuguese',
    location: 'Equatorial Guinea',
    tag: 'pt_GQ',
    name: 'pt-gq',
  },
  {
    language: 'Arabic',
    location: 'Iraq',
    tag: 'ar_IQ',
    name: 'ar-iq',
  },
  {
    language: 'French',
    location: 'Niger',
    tag: 'fr_NE',
    name: 'fr-ne',
  },
  {
    language: 'French',
    location: 'Congo, DRC',
    tag: 'fr_CD',
    name: 'fr-cd',
  },
  {
    language: 'Oromo',
    location: 'Ethiopia',
    tag: 'om_ET',
    name: 'om-et',
  },
  {
    language: 'Sinhala',
    location: 'Sri Lanka',
    tag: 'si_LK',
    name: 'si-lk',
  },
  {
    language: 'Urdu',
    location: 'Islamic Republic of Pakistan',
    tag: 'ur_PK',
    name: 'ur-pk',
  },
  {
    language: 'Basque',
    location: 'Spain',
    tag: 'eu_ES',
    name: 'eu-es',
  },
  {
    language: 'Hawaiian',
    location: 'United States',
    tag: 'haw_US',
    name: 'haw-us',
  },
  {
    language: 'English',
    location: 'Antigua and Barbuda',
    tag: 'en_AG',
    name: 'en-ag',
  },
  {
    language: 'Lingala',
    location: 'Angola',
    tag: 'ln_AO',
    name: 'ln-ao',
  },
  {
    language: 'Portuguese',
    location: 'Guinea-Bissau',
    tag: 'pt_GW',
    name: 'pt-gw',
  },
  {
    language: 'Shona',
    location: 'Latin',
    tag: 'sn_Latn',
    name: 'sn-latn',
  },
  {
    language: 'Arabic',
    location: 'Somalia',
    tag: 'ar_SO',
    name: 'ar-so',
  },
  {
    language: 'Azerbaijani (Cyrillic)',
    location: 'Azerbaijan',
    tag: 'az_Cyrl-AZ',
    name: 'az-cyrl-az',
  },
  {
    language: 'Chinese (Traditional)',
    location: 'Taiwan',
    tag: 'zh_TW',
    name: 'zh-tw',
  },
  {
    language: 'French',
    location: 'Luxembourg',
    tag: 'fr_LU',
    name: 'fr-lu',
  },
  {
    language: 'Russian',
    location: 'Kyrgyzstan',
    tag: 'ru_KG',
    name: 'ru-kg',
  },
  {
    language: 'Catalan',
    location: 'France',
    tag: 'ca_FR',
    name: 'ca-fr',
  },
  {
    language: 'Hausa (Latin)',
    location: 'Nigeria',
    tag: 'ha_Latn-NG',
    name: 'ha-latn-ng',
  },
  {
    language: 'Meru',
    location: 'Kenya',
    tag: 'mer_KE',
    name: 'mer-ke',
  },
  {
    language: 'English',
    location: 'Austria',
    tag: 'en_AT',
    name: 'en-at',
  },
  {
    language: 'English',
    location: 'Guyana',
    tag: 'en_GY',
    name: 'en-gy',
  },
  {
    language: 'English',
    location: 'India',
    tag: 'en_IN',
    name: 'en-in',
  },
  {
    language: 'Italian',
    location: 'San Marino',
    tag: 'it_SM',
    name: 'it-sm',
  },
  {
    language: 'Serbian (Cyrillic)',
    location: 'Serbia and Montenegro (Former)',
    tag: 'sr_Cyrl-CS',
    name: 'sr-cyrl-cs',
  },
  {
    language: 'English',
    location: 'Canada',
    tag: 'en_CA',
    name: 'en-ca',
  },
  {
    language: 'Bemba',
    location: 'Zambia',
    tag: 'bem_ZM',
    name: 'bem-zm',
  },
  {
    language: 'Luyia',
    location: 'Kenya',
    tag: 'luy_KE',
    name: 'luy-ke',
  },
  {
    language: 'Akan',
    location: 'Ghana',
    tag: 'ak_GH',
    name: 'ak-gh',
  },
  {
    language: 'English',
    location: 'American Samoa',
    tag: 'en_AS',
    name: 'en-as',
  },
  {
    language: 'English',
    location: 'Rwanda',
    tag: 'en_RW',
    name: 'en-rw',
  },
  {
    language: 'English',
    location: 'Slovenia',
    tag: 'en_SI',
    name: 'en-si',
  },
  {
    language: 'Kyrgyz',
    location: 'Kyrgyzstan',
    tag: 'ky_KG',
    name: 'ky-kg',
  },
  {
    language: 'English',
    location: 'Netherlands',
    tag: 'en_NL',
    name: 'en-nl',
  },
  {
    language: 'Standard Moroccan Tamazight',
    location: 'Tifinagh',
    tag: 'zgh_Tfng',
    name: 'zgh-tfng',
  },
  {
    language: 'English',
    location: 'Cameroon',
    tag: 'en_CM',
    name: 'en-cm',
  },
  {
    language: 'Arabic',
    location: 'Eritrea',
    tag: 'ar_ER',
    name: 'ar-er',
  },
  {
    language: 'English',
    location: 'Sudan',
    tag: 'en_SD',
    name: 'en-sd',
  },
  {
    language: 'French',
    location: 'French Polynesia',
    tag: 'fr_PF',
    name: 'fr-pf',
  },
  {
    language: 'English',
    location: 'Marshall Islands',
    tag: 'en_MH',
    name: 'en-mh',
  },
  {
    language: 'Jola-Fonyi',
    location: 'Senegal',
    tag: 'dyo_SN',
    name: 'dyo-sn',
  },
  {
    language: 'Finnish',
    location: 'Finland',
    tag: 'fi_FI',
    name: 'fi-fi',
  },
  {
    language: 'Teso',
    location: 'Uganda',
    tag: 'teo_UG',
    name: 'teo-ug',
  },
  {
    language: 'Makonde',
    location: 'Tanzania',
    tag: 'kde_TZ',
    name: 'kde-tz',
  },
  {
    language: 'Central Atlas Tamazight (Latin)',
    location: 'Morocco',
    tag: 'tzm_Latn-',
    name: 'tzm-latn-',
  },
  {
    language: 'Georgian',
    location: 'Georgia',
    tag: 'ka_GE',
    name: 'ka-ge',
  },
  {
    language: 'Pseudo Language',
    location:
      'Pseudo locale for east Asian/complex script localization testing',
    tag: 'qps_ploca',
    name: 'qps-ploca',
  },
  {
    language: 'Spanish',
    location: 'El Salvador',
    tag: 'es_SV',
    name: 'es-sv',
  },
  {
    language: 'Vai (Latin)',
    location: 'Liberia',
    tag: 'vai_Latn-LR',
    name: 'vai-latn-lr',
  },
  {
    language: 'English',
    location: 'Palau',
    tag: 'en_PW',
    name: 'en-pw',
  },
  {
    language: 'Arabic',
    location: 'Algeria',
    tag: 'ar_DZ',
    name: 'ar-dz',
  },
  {
    language: 'North Ndebele',
    location: 'Zimbabwe',
    tag: 'nd_ZW',
    name: 'nd-zw',
  },
  {
    language: 'Pseudo Language',
    location: 'Pseudo locale used for localization testing',
    tag: 'qps_ploc',
    name: 'qps-ploc',
  },
  {
    language: 'Malay',
    location: 'Brunei Darussalam',
    tag: 'ms_BN',
    name: 'ms-bn',
  },
  {
    language: 'Romanian',
    location: 'Moldova',
    tag: 'ro_MD',
    name: 'ro-md',
  },
  {
    language: 'Spanish',
    location: 'Uruguay',
    tag: 'es_UY',
    name: 'es-uy',
  },
  {
    language: 'Telugu',
    location: 'India',
    tag: 'te_IN',
    name: 'te-in',
  },
  {
    language: 'French',
    location: 'Equatorial Guinea',
    tag: 'fr_GQ',
    name: 'fr-gq',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Niger',
    tag: 'ff_Latn-NE',
    name: 'ff-latn-ne',
  },
  {
    language: 'English',
    location: 'Hong Kong',
    tag: 'en_HK',
    name: 'en-hk',
  },
  {
    language: 'English',
    location: 'Malawi',
    tag: 'en_MW',
    name: 'en-mw',
  },
  {
    language: 'English',
    location: 'Norfolk Island',
    tag: 'en_NF',
    name: 'en-nf',
  },
  {
    language: 'Mongolian (Traditional Mongolian)',
    location: "People's Republic of China",
    tag: 'mn_Mong-CN',
    name: 'mn-mong-cn',
  },
  {
    language: 'Tigrinya',
    location: 'Eritrea',
    tag: 'ti_ER',
    name: 'ti-er',
  },
  {
    language: 'Arabic',
    location: 'Comoros',
    tag: 'ar_KM',
    name: 'ar-km',
  },
  {
    language: 'Cherokee',
    location: 'United States',
    tag: 'chr_Cher-US',
    name: 'chr-cher-us',
  },
  {
    language: 'English',
    location: 'Nigeria',
    tag: 'en_NG',
    name: 'en-ng',
  },
  {
    language: 'English',
    location: 'Tokelau',
    tag: 'en_TK',
    name: 'en-tk',
  },
  {
    language: 'French',
    location: 'Central African Republic',
    tag: 'fr_CF',
    name: 'fr-cf',
  },
  {
    language: 'French',
    location: 'Seychelles',
    tag: 'fr_SC',
    name: 'fr-sc',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Mauritania',
    tag: 'ff_Latn-MR',
    name: 'ff-latn-mr',
  },
  {
    language: 'Masai',
    location: 'Kenya',
    tag: 'mas_KE',
    name: 'mas-ke',
  },
  {
    language: 'English',
    location: 'Madagascar',
    tag: 'en_MG',
    name: 'en-mg',
  },
  {
    language: 'English',
    location: 'Tuvalu',
    tag: 'en_TV',
    name: 'en-tv',
  },
  {
    language: 'Catalan',
    location: 'Spain',
    tag: 'ca_ES',
    name: 'ca-es',
  },
  {
    language: 'Filipino',
    location: 'Philippines',
    tag: 'fil_PH',
    name: 'fil-ph',
  },
  {
    language: 'Inuktitut (Latin)',
    location: 'Canada',
    tag: 'iu_Latn-CA',
    name: 'iu-latn-ca',
  },
  {
    language: 'Irish',
    location: 'Ireland',
    tag: 'ga_IE',
    name: 'ga-ie',
  },
  {
    language: 'Punjabi',
    location: 'Islamic Republic of Pakistan',
    tag: 'pa_Arab-PK',
    name: 'pa-arab-pk',
  },
  {
    language: 'French',
    location: 'Chad',
    tag: 'fr_TD',
    name: 'fr-td',
  },
  {
    language: 'Portuguese',
    location: 'Macao SAR',
    tag: 'pt_MO',
    name: 'pt-mo',
  },
  {
    language: 'Swati',
    location: 'Swaziland',
    tag: 'ss_SZ',
    name: 'ss-sz',
  },
  {
    language: 'Arabic',
    location: 'Djibouti',
    tag: 'ar_DJ',
    name: 'ar-dj',
  },
  {
    language: 'Arabic',
    location: 'Egypt',
    tag: 'ar_EG',
    name: 'ar-eg',
  },
  {
    language: 'Spanish',
    location: 'Nicaragua',
    tag: 'es_NI',
    name: 'es-ni',
  },
  {
    language: 'Arabic',
    location: 'Oman',
    tag: 'ar_OM',
    name: 'ar-om',
  },
  {
    language: 'French',
    location: 'Benin',
    tag: 'fr_BJ',
    name: 'fr-bj',
  },
  {
    language: 'Indonesian',
    location: 'Indonesia',
    tag: 'id_ID',
    name: 'id-id',
  },
  {
    language: 'English',
    location: 'Zimbabwe',
    tag: 'en_ZW',
    name: 'en-zw',
  },
  {
    language: 'Sotho',
    location: 'South Africa',
    tag: 'st_ZA',
    name: 'st-za',
  },
  {
    language: 'Welsh',
    location: 'United Kingdom',
    tag: 'cy_GB',
    name: 'cy-gb',
  },
  {
    language: 'Bosnian (Latin)',
    location: 'Bosnia and Herzegovina',
    tag: 'bs_Latn-BA',
    name: 'bs-latn-ba',
  },
  {
    language: 'Koyraboro Senni',
    location: 'Mali',
    tag: 'ses_ML',
    name: 'ses-ml',
  },
  {
    language: 'English',
    location: 'Gibraltar',
    tag: 'en_GI',
    name: 'en-gi',
  },
  {
    language: 'Serbian (Latin)',
    location: 'Bosnia and Herzegovina',
    tag: 'sr_Latn-BA',
    name: 'sr-latn-ba',
  },
  {
    language: 'Turkish',
    location: 'Turkey',
    tag: 'tr_TR',
    name: 'tr-tr',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Liberia',
    tag: 'ff_Latn-LR',
    name: 'ff-latn-lr',
  },
  {
    language: 'Khmer',
    location: 'Cambodia',
    tag: 'km_KH',
    name: 'km-kh',
  },
  {
    language: 'English',
    location: 'Europe',
    tag: 'en_150',
    name: 'en-150',
  },
  {
    language: 'English',
    location: 'Niue',
    tag: 'en_NU',
    name: 'en-nu',
  },
  {
    language: 'Punjabi',
    location: 'India',
    tag: 'pa_IN',
    name: 'pa-in',
  },
  {
    language: 'Kiswahili',
    location: 'Kenya',
    tag: 'sw_KE',
    name: 'sw-ke',
  },
  {
    language: 'Wolof',
    location: 'Senegal',
    tag: 'wo_SN',
    name: 'wo-sn',
  },
  {
    language: 'English',
    location: 'Dominica',
    tag: 'en_DM',
    name: 'en-dm',
  },
  {
    language: 'Tamazight (Latin)',
    location: 'Algeria',
    tag: 'tzm_Latn-DZ',
    name: 'tzm-latn-dz',
  },
  {
    language: 'English',
    location: 'Fiji',
    tag: 'en_FJ',
    name: 'en-fj',
  },
  {
    language: 'French',
    location: 'Algeria',
    tag: 'fr_DZ',
    name: 'fr-dz',
  },
  {
    language: 'Sami (Lule)',
    location: 'Sweden',
    tag: 'smj_SE',
    name: 'smj-se',
  },
  {
    language: 'Faroese',
    location: 'Faroe Islands',
    tag: 'fo_FO',
    name: 'fo-fo',
  },
  {
    language: 'Kinyarwanda',
    location: 'Rwanda',
    tag: 'rw_RW',
    name: 'rw-rw',
  },
  {
    language: 'Nuer',
    location: 'South Sudan',
    tag: 'nus_SS',
    name: 'nus-ss',
  },
  {
    language: 'English',
    location: 'World',
    tag: 'en_001',
    name: 'en-001',
  },
  {
    language: 'French',
    location: 'Madagascar',
    tag: 'fr_MG',
    name: 'fr-mg',
  },
  {
    language: 'French',
    location: 'Vanuatu',
    tag: 'fr_VU',
    name: 'fr-vu',
  },
  {
    language: 'Nepali',
    location: 'Nepal',
    tag: 'ne_NP',
    name: 'ne-np',
  },
  {
    language: 'Dutch',
    location: 'Curaçao',
    tag: 'nl_CW',
    name: 'nl-cw',
  },
  {
    language: "N'ko",
    location: 'Guinea',
    tag: 'nqo_GN',
    name: 'nqo-gn',
  },
  {
    language: 'Sanskrit',
    location: 'India',
    tag: 'sa_IN',
    name: 'sa-in',
  },
  {
    language: 'Spanish',
    location: 'Dominican Republic',
    tag: 'es_DO',
    name: 'es-do',
  },
  {
    language: 'Italian',
    location: 'Switzerland',
    tag: 'it_CH',
    name: 'it-ch',
  },
  {
    language: 'Odia',
    location: 'India',
    tag: 'or_IN',
    name: 'or-in',
  },
  {
    language: 'Tachelhit',
    location: 'Tifinagh, Morocco',
    tag: 'shi_Tfng-MA',
    name: 'shi-tfng-ma',
  },
  {
    language: 'French',
    location: 'Martinique',
    tag: 'fr_MQ',
    name: 'fr-mq',
  },
  {
    language: 'Malay',
    location: 'Malaysia',
    tag: 'ms_MY',
    name: 'ms-my',
  },
  {
    language: 'Tachelhit',
    location: 'Tifinagh',
    tag: 'shi_Tfng',
    name: 'shi-tfng',
  },
  {
    language: 'English',
    location: 'Belgium',
    tag: 'en_BE',
    name: 'en-be',
  },
  {
    language: 'English',
    location: 'Montserrat',
    tag: 'en_MS',
    name: 'en-ms',
  },
  {
    language: 'Yoruba',
    location: 'Benin',
    tag: 'yo_BJ',
    name: 'yo-bj',
  },
  {
    language: 'Thai',
    location: 'Thailand',
    tag: 'th_TH',
    name: 'th-th',
  },
  {
    language: 'Tigre',
    location: 'Eritrea',
    tag: 'tig_ER',
    name: 'tig-er',
  },
  {
    language: 'French',
    location: 'Gabon',
    tag: 'fr_GA',
    name: 'fr-ga',
  },
  {
    language: 'Tigrinya',
    location: 'Ethiopia',
    tag: 'ti_ET',
    name: 'ti-et',
  },
  {
    language: 'English',
    location: 'Pakistan',
    tag: 'en_PK',
    name: 'en-pk',
  },
  {
    language: 'Japanese',
    location: 'Japan',
    tag: 'ja_JP',
    name: 'ja-jp',
  },
  {
    language: 'Kazakh',
    location: 'Kazakhstan',
    tag: 'kk_KZ',
    name: 'kk-kz',
  },
  {
    language: 'Quechua',
    location: 'Bolivia',
    tag: 'quz_BO',
    name: 'quz-bo',
  },
  {
    language: 'Sangu',
    location: 'Tanzania',
    tag: 'sbp_TZ',
    name: 'sbp-tz',
  },
  {
    language: 'Spanish',
    location: 'Spain',
    tag: 'es_ES_tradnl',
    name: 'es-es_tradnl',
  },
  {
    language: 'Lithuanian',
    location: 'Lithuania',
    tag: 'lt_LT',
    name: 'lt-lt',
  },
  {
    language: 'English',
    location: 'Australia',
    tag: 'en_AU',
    name: 'en-au',
  },
  {
    language: 'Fulah',
    location: 'Nigeria',
    tag: 'ff_NG',
    name: 'ff-ng',
  },
  {
    language: 'Koyra Chiini',
    location: 'Mali',
    tag: 'khq_ML',
    name: 'khq-ml',
  },
  {
    language: 'Swedish',
    location: 'Finland',
    tag: 'sv_FI',
    name: 'sv-fi',
  },
  {
    language: 'Shambala',
    location: 'Tanzania',
    tag: 'ksb_TZ',
    name: 'ksb-tz',
  },
  {
    language: 'Arabic',
    location: 'Bahrain',
    tag: 'ar_BH',
    name: 'ar-bh',
  },
  {
    language: 'German',
    location: 'Austria',
    tag: 'de_AT',
    name: 'de-at',
  },
  {
    language: 'German',
    location: 'Germany',
    tag: 'de_DE',
    name: 'de-de',
  },
  {
    language: 'Embu',
    location: 'Kenya',
    tag: 'ebu_KE',
    name: 'ebu-ke',
  },
  {
    language: 'Arabic',
    location: 'Qatar',
    tag: 'ar_QA',
    name: 'ar-qa',
  },
  {
    language: 'Bangla',
    location: 'Bangladesh',
    tag: 'bn_BD',
    name: 'bn-bd',
  },
  {
    language: 'English',
    location: 'Zambia',
    tag: 'en_ZM',
    name: 'en-zm',
  },
  {
    language: 'Russian',
    location: 'Belarus',
    tag: 'ru_BY',
    name: 'ru-by',
  },
  {
    language: 'Lingala',
    location: 'Congo',
    tag: 'ln_CG',
    name: 'ln-cg',
  },
  {
    language: 'Serbian (Latin)',
    location: 'Montenegro',
    tag: 'sr_Latn-ME',
    name: 'sr-latn-me',
  },
  {
    language: 'Uzbek (Cyrillic)',
    location: 'Uzbekistan',
    tag: 'uz_Cyrl-UZ',
    name: 'uz-cyrl-uz',
  },
  {
    language: 'Sami (Southern)',
    location: 'Sweden',
    tag: 'sma_SE',
    name: 'sma-se',
  },
  {
    language: 'Danish',
    location: 'Greenland',
    tag: 'da_GL',
    name: 'da-gl',
  },
  {
    language: 'English',
    location: 'Papua New Guinea',
    tag: 'en_PG',
    name: 'en-pg',
  },
  {
    language: 'English',
    location: 'Vanuatu',
    tag: 'en_VU',
    name: 'en-vu',
  },
  {
    language: 'Interlingua',
    location: 'World',
    tag: 'ia_001',
    name: 'ia-001',
  },
  {
    language: 'Macedonian',
    location: 'North Macedonia',
    tag: 'mk_MK',
    name: 'mk-mk',
  },
  {
    language: 'Tamil',
    location: 'Malaysia',
    tag: 'ta_MY',
    name: 'ta-my',
  },
  {
    language: 'Burmese',
    location: 'Myanmar',
    tag: 'my_MM',
    name: 'my-mm',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Guinea',
    tag: 'ff_Latn-GN',
    name: 'ff-latn-gn',
  },
  {
    language: 'Manx',
    location: 'Isle of Man',
    tag: 'gv_IM',
    name: 'gv-im',
  },
  {
    language: 'English',
    location: 'Lesotho',
    tag: 'en_LS',
    name: 'en-ls',
  },
  {
    language: 'English',
    location: 'South Sudan',
    tag: 'en_SS',
    name: 'en-ss',
  },
  {
    language: 'Tajik (Cyrillic)',
    location: 'Tajikistan',
    tag: 'tg_Cyrl-TJ',
    name: 'tg-cyrl-tj',
  },
  {
    language: 'French',
    location: 'Guinea',
    tag: 'fr_GN',
    name: 'fr-gn',
  },
  {
    language: 'English',
    location: 'Solomon Islands',
    tag: 'en_SB',
    name: 'en-sb',
  },
  {
    language: 'Interlingua',
    location: 'France',
    tag: 'ia_FR',
    name: 'ia-fr',
  },
  {
    language: 'Uzbek',
    location: 'Perso-Arabic',
    tag: 'uz_Arab',
    name: 'uz-arab',
  },
  {
    language: 'English',
    location: 'Guam',
    tag: 'en_GU',
    name: 'en-gu',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Ghana',
    tag: 'ff_Latn-GH',
    name: 'ff-latn-gh',
  },
  {
    language: 'Tatar',
    location: 'Russia',
    tag: 'tt_RU',
    name: 'tt-ru',
  },
  {
    language: 'Maori',
    location: 'New Zealand',
    tag: 'mi_NZ',
    name: 'mi-nz',
  },
  {
    language: 'Bafia',
    location: 'Cameroon',
    tag: 'ksf_CM',
    name: 'ksf-cm',
  },
  {
    language: 'English',
    location: 'Trinidad and Tobago',
    tag: 'en_TT',
    name: 'en-tt',
  },
  {
    language: 'Spanish',
    location: 'Brazil',
    tag: 'es_BR',
    name: 'es-br',
  },
  {
    language: 'Arabic',
    location: 'Yemen',
    tag: 'ar_YE',
    name: 'ar-ye',
  },
  {
    language: 'English',
    location: 'Belize',
    tag: 'en_BZ',
    name: 'en-bz',
  },
  {
    language: 'English',
    location: 'Jersey',
    tag: 'en_JE',
    name: 'en-je',
  },
  {
    language: 'English',
    location: 'Macao SAR',
    tag: 'en_MO',
    name: 'en-mo',
  },
  {
    language: 'Ewe',
    location: 'Togo',
    tag: 'ee_TG',
    name: 'ee-tg',
  },
  {
    language: 'Dutch',
    location: 'Suriname',
    tag: 'nl_SR',
    name: 'nl-sr',
  },
  {
    language: 'English',
    location: 'Uganda',
    tag: 'en_UG',
    name: 'en-ug',
  },
  {
    language: 'Konkani',
    location: 'India',
    tag: 'kok_IN',
    name: 'kok-in',
  },
  {
    language: 'Arabic',
    location: 'Libya',
    tag: 'ar_LY',
    name: 'ar-ly',
  },
  {
    language: 'English',
    location: 'Kenya',
    tag: 'en_KE',
    name: 'en-ke',
  },
  {
    language: 'Turkmen',
    location: 'Turkmenistan',
    tag: 'tk_TM',
    name: 'tk-tm',
  },
  {
    language: 'Tibetan',
    location: 'India',
    tag: 'bo_IN',
    name: 'bo-in',
  },
  {
    language: 'Urdu',
    location: 'India',
    tag: 'ur_IN',
    name: 'ur-in',
  },
  {
    language: 'Asturian',
    location: 'Spain',
    tag: 'ast_ES',
    name: 'ast-es',
  },
  {
    language: 'Ewe',
    location: 'Ghana',
    tag: 'ee_GH',
    name: 'ee-gh',
  },
  {
    language: 'English',
    location: 'Grenada',
    tag: 'en_GD',
    name: 'en-gd',
  },
  {
    language: 'French',
    location: 'Burkina Faso',
    tag: 'fr_BF',
    name: 'fr-bf',
  },
  {
    language: 'Italian',
    location: 'Vatican City',
    tag: 'it_VA',
    name: 'it-va',
  },
  {
    language: 'Belarusian',
    location: 'Belarus',
    tag: 'be_BY',
    name: 'be-by',
  },
  {
    language: 'Chechen',
    location: 'Russia',
    tag: 'cd_RU',
    name: 'cd-ru',
  },
  {
    language: 'Danish',
    location: 'Denmark',
    tag: 'da_DK',
    name: 'da-dk',
  },
  {
    language: 'Dutch',
    location: 'Belgium',
    tag: 'nl_BE',
    name: 'nl-be',
  },
  {
    language: 'English',
    location: 'Saint Kitts and Nevis',
    tag: 'en_KN',
    name: 'en-kn',
  },
  {
    language: 'Lakota',
    location: 'United States',
    tag: 'lkt_US',
    name: 'lkt-us',
  },
  {
    language: 'Ngiemboon',
    location: 'Cameroon',
    tag: 'nnh_CM',
    name: 'nnh-cm',
  },
  {
    language: 'Cornish',
    location: 'United Kingdom',
    tag: 'kw_GB',
    name: 'kw-gb',
  },
  {
    language: 'Assamese',
    location: 'India',
    tag: 'as_IN',
    name: 'as-in',
  },
  {
    language: 'English',
    location: 'Malta',
    tag: 'en_MT',
    name: 'en-mt',
  },
  {
    language: 'Ngomba',
    location: 'Cameroon',
    tag: 'jgo_CM',
    name: 'jgo-cm',
  },
  {
    language: 'Russian',
    location: 'Kazakhstan',
    tag: 'ru_KZ',
    name: 'ru-kz',
  },
  {
    language: 'Rwa',
    location: 'Tanzania',
    tag: 'rwk_TZ',
    name: 'rwk-tz',
  },
  {
    language: 'Sami (Lule)',
    location: 'Norway',
    tag: 'smj_NO',
    name: 'smj-no',
  },
  {
    language: 'Serbian (Cyrillic)',
    location: 'Serbia',
    tag: 'sr_Cyrl-RS',
    name: 'sr-cyrl-rs',
  },
  {
    language: 'Spanish',
    location: 'Philippines',
    tag: 'es_PH',
    name: 'es-ph',
  },
  {
    language: 'English',
    location: 'Singapore',
    tag: 'en_SG',
    name: 'en-sg',
  },
  {
    language: 'French',
    location: 'Rwanda',
    tag: 'fr_RW',
    name: 'fr-rw',
  },
  {
    language: 'Malagasy',
    location: 'Madagascar',
    tag: 'mg_MG',
    name: 'mg-mg',
  },
  {
    language: 'French',
    location: 'New Caledonia',
    tag: 'fr_NC',
    name: 'fr-nc',
  },
  {
    language: 'Italian',
    location: 'Italy',
    tag: 'it_IT',
    name: 'it-it',
  },
  {
    language: 'Uyghur',
    location: "People's Republic of China",
    tag: 'ug_CN',
    name: 'ug-cn',
  },
  {
    language: 'Dzongkha',
    location: 'Bhutan',
    tag: 'dz_BT',
    name: 'dz-bt',
  },
  {
    language: 'German',
    location: 'Luxembourg',
    tag: 'de_LU',
    name: 'de-lu',
  },
  {
    language: 'Bosnian (Cyrillic)',
    location: 'Bosnia and Herzegovina',
    tag: 'bs_Cyrl-BA',
    name: 'bs-cyrl-ba',
  },
  {
    language: 'English',
    location: 'British Virgin Islands',
    tag: 'en_VG',
    name: 'en-vg',
  },
  {
    language: 'Kabuverdianu',
    location: 'Cabo Verde',
    tag: 'kea_CV',
    name: 'kea-cv',
  },
  {
    language: 'Yoruba',
    location: 'Nigeria',
    tag: 'yo_NG',
    name: 'yo-ng',
  },
  {
    language: 'Sena',
    location: 'Mozambique',
    tag: 'seh_MZ',
    name: 'seh-mz',
  },
  {
    language: 'Divehi',
    location: 'Maldives',
    tag: 'dv_MV',
    name: 'dv-mv',
  },
  {
    language: 'English',
    location: 'Switzerland',
    tag: 'en_CH',
    name: 'en-ch',
  },
  {
    language: 'Fulah',
    location: 'Mauritania',
    tag: 'ff_MR',
    name: 'ff-mr',
  },
  {
    language: 'Lao',
    location: 'Lao P.D.R.',
    tag: 'lo_LA',
    name: 'lo-la',
  },
  {
    language: 'Mazanderani',
    location: 'Iran',
    tag: 'mzn_IR',
    name: 'mzn-ir',
  },
  {
    language: 'Portuguese',
    location: 'Portugal',
    tag: 'pt_PT',
    name: 'pt-pt',
  },
  {
    language: 'Afar',
    location: 'Ethiopia',
    tag: 'aa_ET',
    name: 'aa-et',
  },
  {
    language: 'Albanian',
    location: 'Albania',
    tag: 'sq_AL',
    name: 'sq-al',
  },
  {
    language: 'English',
    location: 'Micronesia',
    tag: 'en_FM',
    name: 'en-fm',
  },
  {
    language: 'English',
    location: 'US Virgin Islands',
    tag: 'en_VI',
    name: 'en-vi',
  },
  {
    language: 'Spanish',
    location: 'Latin America',
    tag: 'es_419',
    name: 'es-419',
  },
  {
    language: 'Northern Luri',
    location: 'Iran',
    tag: 'lrc_IR',
    name: 'lrc-ir',
  },
  {
    language: 'Arabic',
    location: 'Syria',
    tag: 'ar_SY',
    name: 'ar-sy',
  },
  {
    language: 'Bodo',
    location: 'India',
    tag: 'brx_IN',
    name: 'brx-in',
  },
  {
    language: 'English',
    location: 'Seychelles',
    tag: 'en_SC',
    name: 'en-sc',
  },
  {
    language: 'French',
    location: 'Cameroon',
    tag: 'fr_CM',
    name: 'fr-cm',
  },
  {
    language: 'Maltese',
    location: 'Malta',
    tag: 'mt_MT',
    name: 'mt-mt',
  },
  {
    language: 'Bulgarian',
    location: 'Bulgaria',
    tag: 'bg_BG',
    name: 'bg-bg',
  },
  {
    language: 'English',
    location: 'Falkland Islands',
    tag: 'en_FK',
    name: 'en-fk',
  },
  {
    language: 'Slovak',
    location: 'Slovakia',
    tag: 'sk_SK',
    name: 'sk-sk',
  },
  {
    language: 'Friulian',
    location: 'Italy',
    tag: 'fur_IT',
    name: 'fur-it',
  },
  {
    language: 'Alsatian',
    location: 'Liechtenstein',
    tag: 'gsw_LI',
    name: 'gsw-li',
  },
  {
    language: 'Greek',
    location: 'Cyprus',
    tag: 'el_CY',
    name: 'el-cy',
  },
  {
    language: 'Guarani',
    location: 'Paraguay',
    tag: 'gn_PY',
    name: 'gn-py',
  },
  {
    language: 'Congo Swahili',
    location: 'Congo DRC',
    tag: 'swc_CD',
    name: 'swc-cd',
  },
  {
    language: 'Croatian (Latin)',
    location: 'Bosnia and Herzegovina',
    tag: 'hr_BA',
    name: 'hr-ba',
  },
  {
    language: 'Fulah (Latin)',
    location: 'Gambia',
    tag: 'ff_Latn-GM',
    name: 'ff-latn-gm',
  },
  {
    language: 'Greek',
    location: 'Greece',
    tag: 'el_GR',
    name: 'el-gr',
  },
  {
    language: 'Malayalam',
    location: 'India',
    tag: 'ml_IN',
    name: 'ml-in',
  },
  {
    language: 'Serbian (Cyrillic)',
    location: 'Bosnia and Herzegovina',
    tag: 'sr_Cyrl-BA',
    name: 'sr-cyrl-ba',
  },
  {
    language: 'English',
    location: 'Saint Lucia',
    tag: 'en_LC',
    name: 'en-lc',
  },
  {
    language: 'Soga',
    location: 'Uganda',
    tag: 'xog_UG',
    name: 'xog-ug',
  },
  {
    language: 'Swedish',
    location: 'Åland Islands',
    tag: 'sv_AX',
    name: 'sv-ax',
  },
  {
    language: 'English',
    location: 'Botswana',
    tag: 'en_BW',
    name: 'en-bw',
  },
  {
    language: 'Sakha',
    location: 'Russia',
    tag: 'sah_RU',
    name: 'sah-ru',
  },
  {
    language: 'Ossetian',
    location: 'Cyrillic, Georgia',
    tag: 'os_GE',
    name: 'os-ge',
  },
  {
    language: 'Slovenian',
    location: 'Slovenia',
    tag: 'sl_SI',
    name: 'sl-si',
  },
  {
    language: 'Portuguese',
    location: 'São Tomé and Príncipe',
    tag: 'pt_ST',
    name: 'pt-st',
  },
  {
    language: 'Spanish',
    location: 'Costa Rica',
    tag: 'es_CR',
    name: 'es-cr',
  },
  {
    language: 'Cebuan (Latin)',
    location: 'Philippines',
    tag: 'ceb_Latn-PH',
    name: 'ceb-latn-ph',
  },
  {
    language: 'French',
    location: 'Djibouti',
    tag: 'fr_DJ',
    name: 'fr-dj',
  },
  {
    language: 'Vai',
    location: 'Liberia',
    tag: 'vai_Vaii-LR',
    name: 'vai-vaii-lr',
  },
  {
    language: 'Venda',
    location: 'South Africa',
    tag: 've_ZA',
    name: 've-za',
  },
  {
    language: 'Portuguese',
    location: 'Angola',
    tag: 'pt_AO',
    name: 'pt-ao',
  },
  {
    language: 'Quechua',
    location: 'Ecuador',
    tag: 'quz_EC',
    name: 'quz-ec',
  },
  {
    language: 'English',
    location: 'Malaysia',
    tag: 'en_MY',
    name: 'en-my',
  },
  {
    language: 'Luxembourgish',
    location: 'Luxembourg',
    tag: 'lb_LU',
    name: 'lb-lu',
  },
  {
    language: 'South Ndebele',
    location: 'South Africa',
    tag: 'nr_ZA',
    name: 'nr-za',
  },
  {
    language: 'Estonian',
    location: 'Estonia',
    tag: 'et_EE',
    name: 'et-ee',
  },
  {
    language: 'French',
    location: 'Morocco',
    tag: 'fr_MA',
    name: 'fr-ma',
  },
  {
    language: 'Mohawk',
    location: 'Canada',
    tag: 'moh_CA',
    name: 'moh-ca',
  },
  {
    language: 'Chiga',
    location: 'Uganda',
    tag: 'cgg_UG',
    name: 'cgg-ug',
  },
  {
    language: 'French',
    location: 'Wallis and Futuna',
    tag: 'fr_WF',
    name: 'fr-wf',
  },
  {
    language: 'Kurdish',
    location: 'Perso-Arabic, Iran',
    tag: 'ku_Arab-IR',
    name: 'ku-arab-ir',
  },
  {
    language: 'Luba-Katanga',
    location: 'Congo DRC',
    tag: 'lu_CD',
    name: 'lu-cd',
  },
  {
    language: 'Tamil',
    location: 'Singapore',
    tag: 'ta_SG',
    name: 'ta-sg',
  },
  {
    language: 'Arabic',
    location: 'Saudi Arabia',
    tag: 'ar_SA',
    name: 'ar-sa',
  },
  {
    language: 'Czech',
    location: 'Czech Republic',
    tag: 'cs_CZ',
    name: 'cs-cz',
  },
  {
    language: 'English',
    location: 'Liberia',
    tag: 'en_LR',
    name: 'en-lr',
  },
  {
    language: 'English',
    location: 'Tonga',
    tag: 'en_TO',
    name: 'en-to',
  },
  {
    language: 'Javanese',
    location: 'Latin, Indonesia',
    tag: 'jv_Latn-ID',
    name: 'jv-latn-id',
  },
  {
    language: 'English',
    location: 'Cayman Islands',
    tag: 'en_KY',
    name: 'en-ky',
  },
  {
    language: 'Bangla',
    location: 'India',
    tag: 'bn_IN',
    name: 'bn-in',
  },
  {
    language: 'English',
    location: 'Denmark',
    tag: 'en_DK',
    name: 'en-dk',
  },
  {
    language: 'Fulah',
    location: 'Senegal',
    tag: 'ff_Latn-SN',
    name: 'ff-latn-sn',
  },
  {
    language: 'Saho',
    location: 'Eritrea',
    tag: 'ssy_ER',
    name: 'ssy-er',
  },
  {
    language: 'Standard Moroccan Tamazight',
    location: 'Morocco',
    tag: 'zgh_Tfng-MA',
    name: 'zgh-tfng-ma',
  },
  {
    language: 'French',
    location: 'Mali',
    tag: 'fr_ML',
    name: 'fr-ml',
  },
  {
    language: 'German',
    location: 'Switzerland',
    tag: 'de_CH',
    name: 'de-ch',
  },
  {
    language: 'Igbo',
    location: 'Nigeria',
    tag: 'ig_NG',
    name: 'ig-ng',
  },
  {
    language: 'Javanese',
    location: 'Latin',
    tag: 'jv_Latn',
    name: 'jv-latn',
  },
  {
    language: 'Kikuyu',
    location: 'Kenya',
    tag: 'ki_KE',
    name: 'ki-ke',
  },
  {
    language: 'Romansh',
    location: 'Switzerland',
    tag: 'rm_CH',
    name: 'rm-ch',
  },
  {
    language: 'Kako',
    location: 'Cameroon',
    tag: 'kkj_CM',
    name: 'kkj-cm',
  },
  {
    language: 'Portuguese',
    location: 'Cabo Verde',
    tag: 'pt_CV',
    name: 'pt-cv',
  },
  {
    language: 'Sami (Northern)',
    location: 'Norway',
    tag: 'se_NO',
    name: 'se-no',
  },
  {
    language: 'Spanish',
    location: 'Peru',
    tag: 'es_PE',
    name: 'es-pe',
  },
  {
    language: 'Taita',
    location: 'Kenya',
    tag: 'dav_KE',
    name: 'dav-ke',
  },
  {
    language: 'Greenlandic',
    location: 'Greenland',
    tag: 'kl_GL',
    name: 'kl-gl',
  },
  {
    language: "Meta'",
    location: 'Cameroon',
    tag: 'mgo_CM',
    name: 'mgo-cm',
  },
  {
    language: 'Tamil',
    location: 'Sri Lanka',
    tag: 'ta_LK',
    name: 'ta-lk',
  },
  {
    language: 'Vunjo',
    location: 'Tanzania',
    tag: 'vun_TZ',
    name: 'vun-tz',
  },
  {
    language: 'English',
    location: 'Cocos [Keeling] Islands',
    tag: 'en_CC',
    name: 'en-cc',
  },
  {
    language: 'French',
    location: 'France',
    tag: 'fr_FR',
    name: 'fr-fr',
  },
  {
    language: 'German',
    location: 'Liechtenstein',
    tag: 'de_LI',
    name: 'de-li',
  },
  {
    language: "K'iche",
    location: 'Guatemala',
    tag: 'quc_Latn-GT',
    name: 'quc-latn-gt',
  },
  {
    language: 'Sami (Inari)',
    location: 'Finland',
    tag: 'smn_FI',
    name: 'smn-fi',
  },
  {
    language: 'Tasawaq',
    location: 'Niger',
    tag: 'twq_NE',
    name: 'twq-ne',
  },
  {
    language: 'Langi',
    location: 'Tanzania',
    tag: 'lag_TZ',
    name: 'lag-tz',
  },
  {
    language: 'Zarma',
    location: 'Niger',
    tag: 'dje_NE',
    name: 'dje-ne',
  },
  {
    language: 'Sami (Skolt)',
    location: 'Finland',
    tag: 'sms_FI',
    name: 'sms-fi',
  },
  {
    language: 'Somali',
    location: 'Ethiopia',
    tag: 'so_ET',
    name: 'so-et',
  },
  {
    language: 'Icelandic',
    location: 'Iceland',
    tag: 'is_IS',
    name: 'is-is',
  },
  {
    language: 'Sesotho sa Leboa',
    location: 'South Africa',
    tag: 'nso_ZA',
    name: 'nso-za',
  },
  {
    language: 'Spanish',
    location: 'Mexico',
    tag: 'es_MX',
    name: 'es-mx',
  },
  {
    language: 'Afar',
    location: 'Eritrea',
    tag: 'aa_ER',
    name: 'aa-er',
  },
  {
    language: 'English',
    location: 'Eritrea',
    tag: 'en_ER',
    name: 'en-er',
  },
  {
    language: 'Kashmiri',
    location: 'Perso-Arabic',
    tag: 'ks_Arab',
    name: 'ks-arab',
  },
  {
    language: 'Afar',
    location: 'Djibouti',
    tag: 'aa_DJ',
    name: 'aa-dj',
  },
  {
    language: 'Gusii',
    location: 'Kenya',
    tag: 'guz_KE',
    name: 'guz-ke',
  },
  {
    language: 'Latvian',
    location: 'Latvia',
    tag: 'lv_LV',
    name: 'lv-lv',
  },
  {
    language: 'English',
    location: 'Finland',
    tag: 'en_FI',
    name: 'en-fi',
  },
  {
    language: 'Arabic',
    location: 'Jordan',
    tag: 'ar_JO',
    name: 'ar-jo',
  },
  {
    language: 'English',
    location: 'Samoa',
    tag: 'en_WS',
    name: 'en-ws',
  },
  {
    language: 'French',
    location: 'Mayotte',
    tag: 'fr_YT',
    name: 'fr-yt',
  },
  {
    language: 'Ukrainian',
    location: 'Ukraine',
    tag: 'uk_UA',
    name: 'uk-ua',
  },
  {
    language: 'Corsican',
    location: 'France',
    tag: 'co_FR',
    name: 'co-fr',
  },
  {
    language: 'Dutch',
    location: 'Sint Maarten',
    tag: 'nl_SX',
    name: 'nl-sx',
  },
  {
    language: 'Inuktitut (Syllabics)',
    location: 'Canada',
    tag: 'iu_Cans-CA',
    name: 'iu-cans-ca',
  },
  {
    language: 'Chinese (Traditional)',
    location: 'Macao S.A.R.',
    tag: 'zh_MO',
    name: 'zh-mo',
  },
  {
    language: 'English',
    location: 'Mauritius',
    tag: 'en_MU',
    name: 'en-mu',
  },
  {
    language: 'French',
    location: 'Syria',
    tag: 'fr_SY',
    name: 'fr-sy',
  },
  {
    language: 'Arabic',
    location: 'Sudan',
    tag: 'ar_SD',
    name: 'ar-sd',
  },
  {
    language: 'French',
    location: 'Comoros',
    tag: 'fr_KM',
    name: 'fr-km',
  },
  {
    language: 'Nyankole',
    location: 'Uganda',
    tag: 'nyn_UG',
    name: 'nyn-ug',
  },
  {
    language: 'Somali',
    location: 'Somalia',
    tag: 'so_SO',
    name: 'so-so',
  },
  {
    language: 'Upper Sorbian',
    location: 'Germany',
    tag: 'hsb_DE',
    name: 'hsb-de',
  },
  {
    language: 'English',
    location: 'Cyprus',
    tag: 'en_CY',
    name: 'en-cy',
  },
  {
    language: 'English',
    location: 'Christmas Island',
    tag: 'en_CX',
    name: 'en-cx',
  },
  {
    language: 'German',
    location: 'Belgium',
    tag: 'de_BE',
    name: 'de-be',
  },
  {
    language: 'Persian',
    location: 'Iran',
    tag: 'fa_IR',
    name: 'fa-ir',
  },
  {
    language: 'English',
    location: 'US Minor Outlying Islands',
    tag: 'en_UM',
    name: 'en-um',
  },
  {
    language: 'Kamba',
    location: 'Kenya',
    tag: 'kam_KE',
    name: 'kam-ke',
  },
  {
    language: 'Russian',
    location: 'Russia',
    tag: 'ru_RU',
    name: 'ru-ru',
  },
  {
    language: 'Arabic',
    location: 'Kuwait',
    tag: 'ar_KW',
    name: 'ar-kw',
  },
  {
    language: 'French',
    location: 'Saint Martin',
    tag: 'fr_MF',
    name: 'fr-mf',
  },
  {
    language: 'Kwasio',
    location: 'Cameroon',
    tag: 'nmg_CM',
    name: 'nmg-cm',
  },
  {
    language: 'English',
    location: 'Sweden',
    tag: 'en_SE',
    name: 'en-se',
  },
  {
    language: 'Machame',
    location: 'Tanzania',
    tag: 'jmc_TZ',
    name: 'jmc-tz',
  },
]
